import { render, staticRenderFns } from "./BankingEdit.vue?vue&type=template&id=2013e352&scoped=true"
import script from "./BankingEdit.vue?vue&type=script&lang=js"
export * from "./BankingEdit.vue?vue&type=script&lang=js"
import style0 from "./BankingEdit.vue?vue&type=style&index=0&id=2013e352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013e352",
  null
  
)

export default component.exports